import { PersonRequest } from "@plinknz/tah-website-elements";

import { personalDetailsConfig } from "../config-generics/personal-details";
import { SurveyConfig } from "../../../components/content-blocks/forms/customer-form-types";
import { confirmationConfig } from "./confirmation";
import { introConfig } from "./intro";
import { whanauConfig } from "./whanau";

export const createSurveyConfig = (member: PersonRequest): SurveyConfig => {
  const personalConfig = personalDetailsConfig(member);

  return {
    pages: [
      ...introConfig,
      ...personalConfig,
      ...whanauConfig,
      ...confirmationConfig,
    ],
  };
};
